// src/components/AuthGuard.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminGuard = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user_cred'));
  if (!user || !user.token || user.roleType !== "admin") {
    return <Navigate to="/admin-login" replace />;
  }
  
  return children;
};

export default AdminGuard;
  

